// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingCreationScreen_container__2WtbK","description":"OnBoardingCreationScreen_description__sPF2N"};